/** * 头部菜单 */
<template>
  <el-popover
    placement="top"
    width="120"
    trigger="hover"
    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
    popper-class="navcon-pop"
  >
    <el-button
      type="text"
      style="margin: 0 auto;display: block;"
      @click="exit()"
      >退出</el-button
    >
    <div class="navcon-title" slot="reference">
      <div class="navcon-flag">
        <img src="../../assets/img/avatar.jpg" alt="" />
      </div>
      <div>超级管理员</div>
    </div>
  </el-popover>

  <!-- <el-menu class="el-menu-demo" mode="horizontal">
    <el-submenu index="2" class="submenu">
      <template slot="title">
        <div class="title">超级管理员</div>
      </template>
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu> -->
</template>
<script>
import { loginout } from "@/api/userMG";
export default {
  name: "navcon",
  data() {
    return {
      collapsed: true,
      imgshow: require("@/assets/img/show.png"),
      imgsq: require("@/assets/img/sq.png"),
      user: {}
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem("userdata"));
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit("logout", "false");
            this.$router.push({ path: "/login" });
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("zh_token");
            this.$message({
              type: "success",
              message: "已退出登录!"
            });
          }, 1000);
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    }
  }
};
</script>
<style scoped>
.navcon-title {
  color: #86909c;
  font-size: 14px;
  height: 44px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navcon-flag {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 8px;
  img{
    width: 100%;
  }
}
</style>
<style>
.navcon-pop {
  padding: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/navcon.vue